/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {GRAVATAR_CONFIG_TOKEN as ɵb} from './lib/gravatar-config.token';
export {NgxGravatarDirective as ɵa} from './lib/ngx-gravatar.directive';